import { render, staticRenderFns } from "./ExcessStats.vue?vue&type=template&id=0378a121&"
import script from "./ExcessStats.vue?vue&type=script&lang=js&"
export * from "./ExcessStats.vue?vue&type=script&lang=js&"
import style0 from "./ExcessStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ExcessStats.vue"
export default component.exports